import { createRoot } from "react-dom/client";
import "./assets/style.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StrictMode } from "react";

const domNode = document.getElementById("root");
const root = createRoot(domNode!);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
